import { pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { text, spacing } = theme;

export const list = css`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const listItem = css`
  display: flex;
  align-items: center;
  margin: ${stack(spacing.md)};
  ${responsiveFontSize(text.xxs)}
`;

export const image = css`
  margin-right: ${pxToRem(spacing.xs)};
`;
